const encryptor = require("simple-encryptor")(process.env.CRYPTO_SECRET_KEY)

export default encryptor
